/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useIntl } from "react-intl";

import { PurposedButtonProps } from "./types";
import { useTheme } from "../../../../config/emotion";
import EwaButton2 from "./EwaButton/EwaButton2";
import { labellessButtonCss } from "./styles";

const ImpersonateButton = (props: PurposedButtonProps) => {
  const { formatMessage } = useIntl();
  const { colors } = useTheme();

  return (
    <EwaButton2
      buttonColor={colors.primaryColor}
      iconName="supervisor_account"
      tooltip={formatMessage({ id: "impersonation.impersonate" })}
      css={labellessButtonCss}
      {...props}
      dataCy="impersonate-button"
    />
  );
};

export default ImpersonateButton;
